// @/hooks/useFairing.ts doc: @https://docs.fairing.co/docs/install-with-nextjs-or-react-app
import { useEffect } from "react";
import { IS_PRODUCTION } from "utils/constants";

const hasValue = (value) => value !== null && value !== undefined && value !== "";

export function useFairing({
	apiKey,
	customerId,
	customerEmail = null,
	orderCount = null,
	orderId = null,
	orderNumber = null,
	orderCreatedAt = null,
	enabled = true
}) {
	useEffect(() => {
		if (!enabled) return;
		if (!apiKey || !customerId) return;

		const loadFairingSDK = () => {
			const existingScript = document.getElementById("fairing-sdk");
			if (existingScript) return;

			const script = document.createElement("script");
			script.src = `https://sdk.fairing.co/sdk/1/fairing.js?t=${Date.now()}`;
			script.id = "fairing-sdk";
			script.type = "module";
			script.defer = true;

			script.onload = () => {
				const opts = {
					config: {
						dismissible: "always",
						test_mode: !IS_PRODUCTION
					}
				};

				const customer = {};
				if (hasValue(customerEmail)) customer.email = customerEmail;
				if (hasValue(orderCount)) customer.order_count = String(orderCount);
				if (Object.keys(customer).length) opts.customer = customer;

				const conversion = {};
				if (hasValue(orderId)) conversion.id = String(orderId);
				if (hasValue(orderNumber)) conversion.number = String(orderNumber);
				if (hasValue(orderCreatedAt)) conversion.created_at = orderCreatedAt;
				if (Object.keys(conversion).length) opts.conversion = conversion;

				window.Fairing = window.Fairing(apiKey, customerId, opts);
				window.Fairing.nextQuestion();
			};

			script.onerror = () => {
				console.error("Failed to load Fairing SDK");
			};

			document.head.appendChild(script);
		};

		const timeoutId = window.setTimeout(loadFairingSDK, 10_000);

		return () => {
			window.clearTimeout(timeoutId);
			const existingScript = document.getElementById("fairing-sdk");
			if (existingScript) {
				existingScript.remove();
			}
		};
	}, [enabled, apiKey, customerId, customerEmail, orderCount, orderId, orderNumber, orderCreatedAt]);
}
